import {Component, computed, HostListener, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ThemeService} from '@/app/core/services/theme/theme.service';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-layout.html',
  styleUrl: './auth-layout.scss'
})
export class AuthLayoutComponent {
  // ✅ Usar inject() para obtener la misma instancia del servicio
  private themeService = inject(ThemeService);

  // ✅ Exponer signals directamente
  // Logo para fondo claro
  logoColorPath = computed(() => this.themeService.getTheme()?.images?.companyLogo?.path);

  // Logo para fondo OSCURO
  logoWhitePath = computed(() => this.themeService.getTheme()?.images?.companyLogoWhite?.path);
  brandName = this.themeService.brandName;
  isMobile = false;

  constructor() {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth <= 576;
  }
}
